module.exports = __webpack_public_path__ + "img/header-img2.c4437b01.png";